import script from "./ScheduleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleDetail.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleDetail.vue?vue&type=style&index=0&id=a3c28d24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3c28d24"]])

export default __exports__